import type { User } from 'firebase/auth'

export default async function getAdmin(user: User) {
  const idTokenResult = await user.getIdTokenResult()

  return !!idTokenResult.claims?.admin
}
